import { useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isArrowKey } from 'packages/pages/utils';
import useEditor from 'packages/hooks/useEditor';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

// Shortcuts positioning for <b>image</b> design.
// Important: Element positioning in <b>video</b> design is implemented in
// usePlaybackShortcuts because it is bound to the video playback
export const useElementPositionShortcuts = ({ isImageDesign }: { isImageDesign: boolean }) => {
    const { manipulationRenderer } = useEditor();
    const isModalOpen = useIsModalOpen();

    useEffect(() => {
        if (!isImageDesign) {
            return;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (
                isInteractiveElement(event) ||
                (!isArrowKey(event) && event.code !== 'KeyF') ||
                !manipulationRenderer ||
                isModalOpen
            ) {
                return;
            }

            manipulationRenderer.canvasManipulation.moveElementWithKeys(event);
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isImageDesign, manipulationRenderer, isModalOpen]);
};
